import CacheStore from 'lib/data/stores/Cache/CacheStore';
import NotificationService from 'lib/services/NotificationService';
import qs from 'qs';
import React from 'react';

export const filterPlaceHolder = (placeholder, params) => {
    if (Object.values(params).some(val => typeof val === "number" || Boolean(val))) {
        return placeholder.filter(user => {
            return Object.keys(params).some(param => {
                return typeof params[param] !== "undefined" && params[param] === user[param]
            });
        })
    } else {
        return placeholder;
    }
}

// disables storing api response data, even if the ui schema says to.
const FORCE_DISABLE_API_STORE = false;

export const apiDataStore = new CacheStore('api_data');

export const filterBody = (data) => {
    return Object.keys(data).filter((key) => data[key]).reduce((dataObj, key) => ({ ...dataObj, [key]: data[key] }), {})
}

export const makeApiCall = ({
    startCallMessage = '',
    successMessage = '',
    failureMessage = '',
    params = {},
    url = '',
    method,
    data,
    config,
    extractPath,
    updateInDataStore = false,
    dataStorePath = '',
    shouldShowNotifications = true
}) => new Promise(async (resolve, reject) => {

    if (shouldShowNotifications) {
        NotificationService.notifyInfo(startCallMessage, React.createElement('progress'), { duration: 1 });
    }

    const queryParams = qs.stringify(filterBody(params)) || '';
    const fullUrl = `${url}${queryParams ? '?' : ''}${queryParams}`
    let response;

    try {
        if (data) {
            response = await method(fullUrl, filterBody(data), config || undefined);
        } else if (config) {
            response = await method(fullUrl, config);
        } else {
            response = await method(fullUrl);
        }
    } catch (e) {
        console.log('CAUGHT ERROR', e, e.message, e.error)
        reject(e);
    }

    //console.log('response::: ', response)
    if (!response) {
        return reject(response)
    }
    if (response.data && typeof response.data.success !== typeof undefined && !response.data.success)
        return reject(response.data);

    return resolve(response.data);
})
    .then(result => extractPath(result))
    .then(result => {
        if (shouldShowNotifications) {
            NotificationService.notifySuccess('Success', successMessage, { duration: 1 });
        }

        if (updateInDataStore && !FORCE_DISABLE_API_STORE) {
            apiDataStore.set(dataStorePath, result);
        }

        return result;
    })
    .catch((data = {}) => {
        console.log('failed api call', data)
        const fail = typeof data.error === "string" ? data.error : failureMessage
        if (shouldShowNotifications) {
            NotificationService.notifyError('Authentication Error', fail);
        }
        return {
            success: false,
            error: fail
        };
    })
